module.exports = __webpack_public_path__ + "static/media/registry-video.5a587875.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/registry-video.jpg
// module id = 1791
// module chunks = 50